import { createSlice } from '@reduxjs/toolkit';

import extraReducers from './extraReducers';
import { initialState } from './initialState';
import reducers from './reducers';

const messagingSlice = createSlice({
    name: 'messaging',
    initialState,
    reducers: reducers,
    extraReducers: extraReducers,
});

export const {
    updateActiveExpertConversationId,
    updateConversationStatus,
    updateConversationStatuses,
    updateLatestConversationEventTimestamp,
    updateHaveUnreadMessages,
} = messagingSlice.actions;

export default messagingSlice.reducer;
